// USA
export const locale = {

   MENU: {
      CREATE: "Create",
      MY_REPORT: "My Reports",
   },

   TOPBAR: {
      HI: 'Hi',
      QUICKUSER: {
         TITLE: 'User Profile',
         BUTTON: 'Sign out',
         AHREF: {
            TITLE: 'My Profile',
            TITLE_DESC: 'Account settings and more'
         },
         ACTIVITIES: {
            TITLE: 'Recent Activities'
         }
      }
   },

   AUTH: {
      LOGIN: {
         TITLE: "Login Account",
         WELCOME: "Welcome Back!",
         WELCOME_DESC: 'Sign in to your account',
         SCREENSHOT: "Screenshot any web page and proof it",
         SCREENSHOT_DESC: "Create a proof of any website content and get them stored in the blockchain.",
         BUTTON: {
            GOOGLE: "Sign in with Google",
            FACEBOOK: "Sign in with Facebook"
         },
         TERMS_MESSAGE: "Click “Sign In” to agree to Externalis Terms of Service and acknowledge that Externalis Privacy Policy applies to you."
      }
   },

   MODAL: {
      QRCODE: {
         TITLE: 'Report hash',
         TITLE_DESC: 'Simply scan or copy the report hash to verify',
         OR: 'Or',
         COPY: 'Copy'
      },
      VERIFY: {
         VERIFY_REPORT: {
            TITLE: 'Verify Report',
            TITLE_DESC: 'Upload any report and verify if it’s on the blockchain',
            BUTTONS: {
               UPLOAD: 'Upload',
               PDF_WARNING: 'Only PDF is supported',
               VERIFY_REPORT: 'Verify Report'
            },
            CANCEL: 'Cancel',
            UPLOADING: 'Uploading...',
            INPUT: {
               PLACEHOLDER: 'Enter the blockchain hash of the report',
               VALIDATIONS: {
                  REQUIRED_FIELD: 'Field is required',
                  INVALID_FIELD: 'Report hash is invalid'
               }
            }
         },
         REPORT_VERIFIED: {
            TITLE: 'Report Found',
            TITLE_DESC: 'This is a valid report which was uploaded to the Ethereum blockchain',
            DATE_AND_TIME: 'Date and time of upload',
            LINK_TO_REPORT: 'Link to report hash on Blockchain',
            BUTTON: 'Verify Another Report'
         },
         REPORT_NOT_FOUND: {
            TITLE: 'Report Hash not found',
            TITLE_DESC: 'This is an invalid report which was not uploaded to the Etheruem blockchain',
            BUTTON: 'Verify Another Report'
         }
      }
   },

   CREATE: {
      HEADER: {
         TITLE: "Create a Report",
         TITLE_DESC: "Create a Report"
      },
      INIT: {
         FORM: {
            TITLE: "Create a Screen Capture Report",
            TITLE_DESC: "We will analyze it, pull all the right information and you will have access the report in your email.",
            CHECK_OPTION: {
               DEACTIVATE_JS: "Deactivate Javascript",
               FULL_PAGE_CAPTURE: "Full Page capture"
            },
            RADIO_OPTION: {
               TITLE: "Choose the blockchain to which you wish to write.",
               NONE: "None"
            },
            BUTTON: "Create Report"
         }
      },
      COMPILING: {
         TITLE: 'Your report is being compiled',
         TITLE_DESC: 'Please wait for some moment while we compile your report.',
         SERVER_ERROR: 'Server encountered error, please try again'
      },
      CREATED: {
         CONGRATULATION: 'Congratulations your report will be email to you',
         OR: 'Or',
         BUTTON: 'Download Report'
      }
   },

   REPORTS: {
      HEADER: {
         TITLE: "My Reports",
         TITLE_DESC: "My Reports"
      },
      INIT: {
         HEADER: {
            TITLE: 'REPORTS',
            TITLE_DESC: 'All created reports will appear here',
            BUTTON: 'Verify'
         },
         THEADS: {
            DATE: 'Date',
            URL: 'URL',
            REPORT_HASH: 'REPORT HASH'
         }
      }
   }
};
